module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Liquidación a proveedor")]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn-link pull-right",
    attrs: {
      "to": "/liquidaciones/proveedores"
    }
  }, [_vm._v("Volver a la lista")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('combo-proveedores', {
    model: {
      value: (_vm.empresa),
      callback: function($$v) {
        _vm.empresa = $$v
      },
      expression: "empresa"
    }
  }), _vm._v(" "), (!_vm.$v.empresa.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe seleccionar una empresa")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Comisión")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comision),
      expression: "comision"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.comision)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comision = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Desde")]), _vm._v(" "), _c('date-picker', {
    model: {
      value: (_vm.filtros.desde),
      callback: function($$v) {
        _vm.filtros.desde = $$v
      },
      expression: "filtros.desde"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Hasta")]), _vm._v(" "), _c('date-picker', {
    model: {
      value: (_vm.filtros.hasta),
      callback: function($$v) {
        _vm.filtros.hasta = $$v
      },
      expression: "filtros.hasta"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn pull-right btn-fill",
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": _vm.changeProveedor
    }
  }, [_vm._v("\n                    Aplicar\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Liquidación")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.liquidacion),
      expression: "liquidacion"
    }],
    ref: "slLiquidaciones",
    staticClass: "form-control select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.liquidacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nueva liquidación")]), _vm._v(" "), _vm._l((_vm.liquidaciones), function(liquidacion) {
    return _c('option', {
      key: liquidacion._id,
      domProps: {
        "value": liquidacion._id
      }
    }, [_vm._v(_vm._s(liquidacion.numero))])
  })], 2)])]), _vm._v(" "), (_vm.sucursales.length > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sucursal),
      expression: "filtros.sucursal"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtros.sucursal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.sucursales), function(sucursal) {
    return _c('option', {
      key: sucursal._id,
      domProps: {
        "value": sucursal._id
      }
    }, [_vm._v(_vm._s(sucursal.empresa.razonSocial) + "-" + _vm._s(sucursal.denominacion))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.filtros.sucursal !== '-1') ? _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Combo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.combo),
      expression: "filtros.combo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtros.combo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.combosFiltrados), function(combo) {
    return _c('option', {
      key: combo._id,
      domProps: {
        "value": combo._id
      }
    }, [_vm._v(_vm._s(combo.nombre))])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": _vm.clickLiquidar
    }
  }, [(!_vm.liquidacion) ? [_vm._v("Crear liquidación")] : [_vm._v("Agregar entregas a liquidación")]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('button', {
    staticClass: "btn btn-fill btn-xs",
    on: {
      "click": _vm.seleccionarTodos
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])]), _vm._v(" "), _c('th', [_vm._v("Número")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Usuario")]), _vm._v(" "), _c('th', [_vm._v("Combo")]), _vm._v(" "), _c('th', [_vm._v("Monto")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.entregasFiltradas), function(entrega, a) {
    return [_c('tr', [_c('td', [_c('div', {
      staticClass: "smart-form"
    }, [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (entrega.seleccionada),
        expression: "entrega.seleccionada"
      }],
      staticClass: "selectable",
      attrs: {
        "type": "checkbox",
        "id": 'selectable' + a
      },
      domProps: {
        "checked": Array.isArray(entrega.seleccionada) ? _vm._i(entrega.seleccionada, null) > -1 : (entrega.seleccionada)
      },
      on: {
        "__c": function($event) {
          var $$a = entrega.seleccionada,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (entrega.seleccionada = $$a.concat($$v))
            } else {
              $$i > -1 && (entrega.seleccionada = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            entrega.seleccionada = $$c
          }
        }
      }
    }), _vm._v(" "), _c('i')])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatFecha")(entrega.fechaEntrega)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.usuario.displayName) + "-"), _c('b', [_vm._v(_vm._s(entrega.sucursal.empresa.razonSocial) + " " + _vm._s(entrega.sucursal.denominacion))])]), _vm._v(" "), (entrega.combo) ? _c('td', [_vm._v(_vm._s(entrega.combo.nombre))]) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatMoneda")(entrega.montoBruto)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.estado))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-link btn-xs",
      on: {
        "click": function($event) {
          entrega.verDetalle = !entrega.verDetalle
        }
      }
    }, [_vm._v("Ver detalle")])])]), _vm._v(" "), (entrega.verDetalle) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_c('tbody', _vm._l((entrega.platos), function(plato) {
      return _c('tr', [_c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(plato.cantidad) + "x")]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "3"
        }
      }, [_vm._v(_vm._s(plato.plato.nombre))])])
    }))])])]) : _vm._e()]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38a127ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Liquidaciones/FormProveedores.vue
// module id = 1121
// module chunks = 5